import { createFileRoute } from '@tanstack/react-router'
import { TicketAttribute } from '@/components/settings-route/ticket/attribute/index.jsx'

export const Route = createFileRoute('/_auth/settings/tickets/attributes')({
  component: TicketAttribute,
})
